import { Dispatch, SetStateAction } from 'react';
import { ApiGeolocation } from '../services/api.geolocation';

export function loadLocationBrowser(set_country: Dispatch<SetStateAction<{value: string, valid: boolean}>>) {
  ApiGeolocation.getLocateIPAddress().then( (response) => {
    if (response) {
      set_country({value: response.country_code, valid: true})
    }
  }).catch( (error) => {
    set_country({value: '', valid: false})
    alert(error)
  })
}
